<template>
  <div class="sign">
    <section class="signature">
      <div class="signatureBox">
        <div class="toolBar">
          <div class="lineWidth">
            <template v-for="(item,index) in border">
              <span :key="index" :style="`width:${item}px;background:${item===lineWidth?'#1E90FF':'#000'}`" @click="lineWidth=item"></span>
            </template>
          </div>
          <div class="color">
            <template v-for="(item,index) in colorList">
              <span :class="{active:color===item}" :key="index" :style="`background:${item}`" @click="color=item"></span>
            </template>
          </div>
        </div>
        <div class="canvasBox" ref="canvasHW">
          <canvas ref="canvasF" class="canvasStyle" @touchstart='touchStart' @touchmove='touchMove' @touchend='touchEnd' @mousedown="mouseDown" @mousemove="mouseMove" @mouseup="mouseUp"></canvas>
        </div>
      </div>
    </section>
    <div slot="footer" class="dialog-footer" style="text-align:center">
      <el-button type="text" @click="handleDefault" icon="el-icon-star-on" style="float:right;color:#808080;margin-right:20px">
        默认签名
      </el-button>      
      <el-button style="margin-left:90px" @click="overwrite" icon="el-icon-refresh">重置</el-button>
      <el-button type="primary" @click="commit" icon="el-icon-check">提交</el-button>      
    </div>
  </div>
</template>
<script>
export default {
  name:'sign',
  props:{
    currentImg: undefined
  },
  data() {
      return {
        stageInfo:'',
        imgUrl:'',
        points: [],
        canvasTxt: null,
        startX: 0,
        startY: 0,
        moveY: 0,
        moveX: 0,
        endY: 0,
        endX: 0,
        w: null,
        h: null,
        isDown: false,
        color: '#000000',
        lineWidth: 1,
        border:[1,2,3,4],
        colorList:['#000000', '#ff5566', '#ff9900', '#ffe14c', '#00bf3a', '#14d7d5', '#409eff', '#9537de']
      }
    },
    mounted() {
      let canvas = this.$refs.canvasF
      canvas.height = this.$refs.canvasHW.offsetHeight -0
      canvas.width = this.$refs.canvasHW.offsetWidth - 0
      this.canvasTxt = canvas.getContext('2d')
      this.canvasTxt.lineWidth = this.lineWidth
      this.canvasTxt.fillStyle = this.color
      this.canvasTxt.strokeStyle = this.color      
      this.stageInfo = canvas.getBoundingClientRect()
      this.overwrite()
      
      // 还原签名
      if( this.currentImg !== undefined ){
        var myImage = new Image()
        myImage.src = this.currentImg        
        const that = this
        myImage.onload = () => {
          this.canvasTxt.drawImage(myImage, 0, 0)
        }
      } 
    },
    watch: {
      color(newVal) {
        this.canvasTxt.fillStyle = newVal
        this.canvasTxt.strokeStyle = newVal
      },
      lineWidth(newVal) {
        this.canvasTxt.lineWidth = newVal
      }
    },
    methods: {
      // 设置白底
      setCanvasBg() {
        let canvas = this.$refs.canvasF
        let imageData = this.canvasTxt.getImageData(0, 0, canvas.width, canvas.height);   
        for(var i = 0; i < imageData.data.length; i += 4) {    
          if(imageData.data[i + 3] == 0) {   
              imageData.data[i] = 255;   
              imageData.data[i + 1] = 255;   
              imageData.data[i + 2] = 255;   
              imageData.data[i + 3] = 255;    
          }   
        }  
        this.canvasTxt.putImageData(imageData, 0, 0) 
      },
      handleDefault() {
        this.$emit('handleDefault')
      },
      //mobile
      touchStart(ev) {
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clienX,
            y: ev.targetTouches[0].clientY,
          }
          this.startX = obj.x
          this.startY = obj.y
          this.canvasTxt.beginPath()
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
        }
      },
      touchMove(ev) {
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - this.stageInfo.left,
            y: ev.targetTouches[0].clientY - this.stageInfo.top
          }
          this.moveY = obj.y
          this.moveX = obj.x
          this.canvasTxt.beginPath()
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.startY = obj.y
          this.startX = obj.x
          this.points.push(obj)
        }
      },
      touchEnd(ev) {
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - this.stageInfo.left,
            y: ev.targetTouches[0].clientY - this.stageInfo.top
          }
          this.canvasTxt.beginPath()
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
        }
      },
      //pc
      mouseDown(ev) {
        ev = ev || event
        ev.preventDefault()
        if (1) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          }
          this.startX = obj.x
          this.startY = obj.y
          this.canvasTxt.beginPath()
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
 
          // this.canvasTxt.strokeRect(20,20,80,100);
          this.canvasTxt.closePath()
          this.points.push(obj)
          this.isDown = true
        }
      },
      mouseMove(ev) {
        ev = ev || event
        ev.preventDefault()
        if (this.isDown) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          }
          this.moveY = obj.y
          this.moveX = obj.x
          this.canvasTxt.beginPath()
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.startY = obj.y
          this.startX = obj.x
          this.points.push(obj)
        }
      },
      mouseUp(ev) {
        ev = ev || event
        ev.preventDefault()
        if (this.isDown) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          }
          this.canvasTxt.beginPath()
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
          this.points.push({x: -1, y: -1})
          this.isDown = false
        }
      },
      //重写
      overwrite() {
        this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height)
        this.points = []
        this.setCanvasBg()
      },
      //确定签名
      commit() {
        this.imgUrl=this.$refs.canvasF.toDataURL("image/jpeg")
        this.$emit('handleSaveSignature', this.imgUrl) 
        this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height)
        this.points = []
      },      
    },
}
</script>
<style lang="scss">
// 签名样式很重要，会影响触点位置
.sign{
    width: 100%;
    position: relative;
}
.signature{
  width: 100%;
  border: 1px solid #ebeef5;
  margin-bottom: 20px;
}


.signatureBox {
  width: 100%;
  margin: 0 auto;
  height: 400px;
  box-sizing: border-box;
  background: #fff;
  .toolBar {
    overflow: hidden;
    padding: 10px;
    width: 95%;
    height: 40px;
    border-bottom: 1px solid #ebeef5;
    margin: 0 auto;
    .lineWidth{
      float: left;
      span{
        display: inline-block;
        height: 14px;
        background: #000;
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .color{
      float: left;
      border-left: 1px solid #ebeef5;
      height: 15px;
      margin-left: 5px;
      span{
        display: inline-block;
        height: 14px;
        width: 14px;
        margin-left: 14px;        
        cursor: pointer;
      }
      span.active{
        position: relative;
      }
      span.active::after{
        content: '●';
        position: absolute;
        color:#fff;
        left: 50%;
        margin-left: -4.5px;
        top: 50%;
        margin-top: -11px;
      }
    }
  }
}
.canvasBox {
  width: 100%;
  height: calc(100% - 41px); 
  canvas{
    width: 100%;
    height: 100%;
  }
}
</style>